import { useCallback, useState } from 'react';
import { ArrowContainer, Popover as RTPopover } from 'react-tiny-popover';
import styled from 'styled-components';
import type { IPopoverProps } from './Popover.types';

// https://www.npmjs.com/package/react-tiny-popover
const Popover = ({ reposition, className, content, children }: IPopoverProps) => {
	const showPopover = !!content;
	const [isOpen, setIsOpen] = useState(false);
	const onOpen = useCallback(() => setIsOpen(true), []);
	const onClose = useCallback(() => setIsOpen(false), []);

	return (
		<div className={className}>
			<RTPopover
				isOpen={showPopover ? isOpen : false}
				// isOpen
				positions={['top', 'left', 'right', 'bottom']} // if you'd like, you can limit the positions
				padding={10}
				reposition={reposition}
				content={({ position, childRect, popoverRect }) => (
					<StyledArrowContainer // if you'd like an arrow, you can import the ArrowContainer!
						position={position}
						childRect={childRect}
						popoverRect={popoverRect}
						arrowColor="red"
						arrowSize={8}
						className="popover-arrow-container"
						arrowClassName="popover-arrow"
					>
						<ArrowContentWrapper>{content}</ArrowContentWrapper>
					</StyledArrowContainer>
				)}
			>
				<PopoverWrapper
					className={className}
					onMouseOver={onOpen}
					onFocus={onOpen}
					onMouseOut={onClose}
					onBlur={onClose}
					$showPopover={showPopover}
				>
					{children}
				</PopoverWrapper>
			</RTPopover>
		</div>
	);
};

const StyledArrowContainer = styled(ArrowContainer)`
	--color: ${({ theme }) => theme.v2.color.neutral[600]};

	background-color: ${({ theme }) => theme.v2.color.white[500]};
	border: 1px solid var(--color);
	border-radius: 2px;
	padding: 1rem;

	.popover-arrow {
		transform: translate(0, 100%);
		border-top-color: var(--color) !important;
		bottom: 0px !important;
		opacity: 0.8;
	}
`;

export const PopoverWrapper = styled.div<{ $showPopover?: boolean }>`
	${({ $showPopover }) => $showPopover && 'cursor: help'};
`;

const ArrowContentWrapper = styled.div`
	padding: 0.5rem;
	white-space: pre-line;
	text-align: center;
`;
const _PopoverExport = styled(Popover)``;

export { _PopoverExport as Popover };
